import { DogeWalletAdapter, SignPsbtDogeOptions } from '../types';

declare global {
  interface Window {
    dogeuni: {
      requestAccounts: () => Promise<string[]>;
      getAccounts: () => Promise<string[]>;
      getPublicKey: () => Promise<string>;
      signPsbt: (psbt: string, options?: SignPsbtDogeOptions) => Promise<string>;
    };
  }
}

export class DogeUniAdapter implements DogeWalletAdapter {
  name = 'DogeUni';
  icon = '/wallets/dogeuni.svg';
  link = 'https://dogeuni.com/wallet';
  isConnected = false;
  address: string | null = null;

  openLinkIfNotReady() {
    if (!window.dogeuni) {
      window.open(this.link, '_blank');
      return;
    }
  }

  async connect() {
    this.openLinkIfNotReady();
    const accounts = await window.dogeuni.requestAccounts();
    this.isConnected = true;
    this.address = accounts[0];
  }
  disconnect() {
    this.isConnected = false;
    this.address = null;
  }

  async getPublicKey() {
    this.openLinkIfNotReady();
    return window.dogeuni.getPublicKey();
  }

  async signPsbt(psbt: string, options?: SignPsbtDogeOptions) {
    return window.dogeuni.signPsbt(psbt, options);
  }
}
